// extracted by mini-css-extract-plugin
module.exports = {"l":"Subheading-module__l___3gVFp","bold":"Subheading-module__bold___1_LId","m":"Subheading-module__m___4JBdq"};